import type { App } from 'vue'
import store from '@/plugins/store'
import i18n from '@/plugins/i18n'
import router from '@/plugins/router'
import libs from '@/plugins/libs'
import chart from '@/plugins/chart'
import matomo from '@/plugins/matomo'
import theme from '@/plugins/theme'

export default {
  install: async (app: App<Element>) => {
    app.use(router).use(store).use(i18n).use(theme).use(matomo).use(chart).use(libs)
  },
}
